<template>
  <svg
    class="drag-handle cursor-grab"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  >
    <line
      x1="5"
      y1="9"
      x2="19"
      y2="9"
    />
    <line
      x1="5"
      y1="15"
      x2="19"
      y2="15"
    />
  </svg>
</template>
